// src/components/operationCenter/widgets/GlobalM2Widget.tsx
// Widget wrapper for Global M2 liquidity chart

import React, { useRef, useState, useEffect } from "react";
import type { WidgetProps } from "@/types/dashboard";
import { GlobalM2Chart } from "@/components/indices/GlobalM2Chart";

const GlobalM2Widget: React.FC<WidgetProps> = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerHeight, setContainerHeight] = useState(300);

  // Measure container height for ECharts
  useEffect(() => {
    const updateHeight = () => {
      if (containerRef.current) {
        const height = containerRef.current.clientHeight;
        if (height > 0) {
          setContainerHeight(height);
        }
      }
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(updateHeight);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="h-full w-full overflow-hidden">
      <GlobalM2Chart height={containerHeight} />
    </div>
  );
};

export default GlobalM2Widget;

